import React from "react";
import ListFilterPanel from "@/components/Shared/Filters/ListFilterPanel";
import {
	CustomerFilterDefinition,
	CustomerSavedFilter,
	EMPTY_CUSTOMER_DEFINITION,
	customerDefinitionsEqual,
	isEmptyCustomerDefinition,
} from "../../../models/CustomerFilter";
import CustomerFilterBuilder from "./CustomerFilterBuilder";
import { CustomerFilterOptions } from "./useCustomerFilterData";

interface Props {
	isOpen: boolean;
	onClose: () => void;
	definition: CustomerFilterDefinition;
	onChange: (def: CustomerFilterDefinition) => void;
	options: CustomerFilterOptions;
	savedFilters: CustomerSavedFilter[];
	/** org-defined filters, shown read-only in the manage view for context */
	orgFilters?: CustomerSavedFilter[];
	/** id of the saved filter currently being edited (the "base"), if any */
	activeSavedId?: string;
	onSaveNew: (name: string, def: CustomerFilterDefinition) => void;
	onUpdateSaved: (id: string, def: CustomerFilterDefinition) => void;
	onRenameSaved: (id: string, name: string) => void;
	onDeleteSaved: (id: string) => void;
	onReorderSaved: (ordered: CustomerSavedFilter[]) => void;
}

/**
 * The customer list's filter drawer. A thin wrapper over the shared
 * `ListFilterPanel`, supplying the customer `CustomerFilterBuilder` and the
 * customer definition's empty/equality helpers.
 */
const CustomerFilterPanel: React.FC<Props> = ({ options, ...rest }) => (
	<ListFilterPanel
		{...rest}
		isEmptyDefinition={isEmptyCustomerDefinition}
		definitionsEqual={customerDefinitionsEqual}
		emptyDefinition={EMPTY_CUSTOMER_DEFINITION}
		renderBuilder={(def, change) => (
			<CustomerFilterBuilder definition={def} onChange={change} options={options} />
		)}
	/>
);

export default CustomerFilterPanel;
